import * as React from 'react';
import { observer } from 'mobx-react';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import ExternalImagesOptionType from '../data/store/schema/ExternalImagesOptionType';
import getSelectedOptionKey from '../selectors/getSelectedOptionKey';
import strings from 'owa-strings/owa-options-strings';
import selectExternalImagesOption from '../data/mutators/selectExternalImagesOption';

/**
 * Component that renders the External Images option in the settings panel.
 */
export default observer(function ExternalImagesFull() {
    const externalImagesDisplayOptions = [
        {
            key: ExternalImagesOptionType.Display.toString(),
            text: strings.option_privacy_externalimages_display_choice,
        },
        {
            key: ExternalImagesOptionType.Block.toString(),
            text: strings.option_privacy_externalimages_block_choice,
        },
    ];

    return (
        <ChoiceGroup
            label={strings.option_privacy_externalimages_description}
            options={externalImagesDisplayOptions}
            onChange={onOptionChanged}
            selectedKey={`${getSelectedOptionKey().toString()}`}
        />
    );
});

const onOptionChanged = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: IChoiceGroupOption
) => option && selectExternalImagesOption(parseInt(option.key, 10));
